import { render, staticRenderFns } from "./DormRoomList.vue?vue&type=template&id=83fbbb02&scoped=true&"
import script from "./DormRoomList.vue?vue&type=script&lang=js&"
export * from "./DormRoomList.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomList.vue?vue&type=style&index=0&id=83fbbb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fbbb02",
  null
  
)

export default component.exports